import {
  Drawer,
  DrawerBody,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  Box,
  Text,
  VStack,
  Button,
  Spinner,
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import axiosInstance from "../../config/axiosInstance";

const NotificationDrawer = ({ isOpen, onClose, setUnreadCount }) => {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!isOpen) return;

    const fetchNotifications = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get("/api/notifications");
        const fetched = res.data.notifications || [];

        // Mark all unread as read immediately in frontend
        const updated = fetched.map((n) => ({ ...n, isRead: true }));
        setNotifications(updated);

        if (setUnreadCount) {
          setUnreadCount(0); // All unread are now marked read
        }

        // Mark all unread as read in backend
        const unreadIds = fetched.filter((n) => !n.isRead).map((n) => n._id);
        if (unreadIds.length > 0) {
          await Promise.all(
            unreadIds.map((id) =>
              axiosInstance.patch(`/api/notifications/${id}/mark-read`)
            )
          );
        }
      } catch (err) {
        console.error("Failed to fetch notifications", err);
      } finally {
        setLoading(false);
      }
    };

    fetchNotifications();
  }, [isOpen, setUnreadCount]);

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="sm">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerBody pt={10} pb={6}>
          <VStack spacing={4} align="stretch" maxH="85vh" overflowY="auto">
            {loading ? (
              <Spinner />
            ) : notifications.length === 0 ? (
              <Text textAlign="center" color="gray.500">
                No notifications found.
              </Text>
            ) : (
              notifications.map((n) => (
                <Box
                  key={n._id}
                  p={4}
                  bg="blue.50"
                  borderRadius="md"
                  boxShadow="sm"
                >
                  <Text fontWeight="bold">Notification</Text>
                  <Text fontSize="sm" color="gray.600">
                    {new Date(n.createdAt).toLocaleString()}
                  </Text>

                  {/* Always expanded */}
                  <Box mt={3} p={3} bg="white" borderRadius="md" boxShadow="sm">
                    <Text whiteSpace="pre-wrap">{n.message}</Text>
                    <Button
                      mt={3}
                      size="sm"
                      colorScheme="red"
                      onClick={() =>
                        setNotifications((prev) =>
                          prev.filter((item) => item._id !== n._id)
                        )
                      }
                    >
                      OK
                    </Button>
                  </Box>
                </Box>
              ))
            )}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
};

export default NotificationDrawer;
